import { render, staticRenderFns } from "./AddOnEditor.vue?vue&type=template&id=2b04b8d6"
import script from "./AddOnEditor.vue?vue&type=script&lang=ts"
export * from "./AddOnEditor.vue?vue&type=script&lang=ts"
import style0 from "./AddOnEditor.vue?vue&type=style&index=0&id=2b04b8d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports